// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    margin: 0;
    height: 100%;
    overflow: hidden;
    font-family: "nunito sans", sans-serif;
    font-size: 16px;
}

h1 {
    font-size: 2em;
    font-weight: 800;
    color: #5bb752;
}

h2 {
    font-size: 1.5em;
    font-weight: 800;
    color: #5bb752;
}

h3 {
    font-size: 1.1em;
    font-weight: 600;
    color: #5bb752;
}

h4 {
    font-size: 1em;
    font-weight: 600;
    color: #5bb752;
}

p {
    font-size: 1em;
    font-weight: 400;
    color: #000;
}

.hidden {
    display: none!important;
}

#loading-spinner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000; /* Higher than other elements */
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #5bb752; /* Match your theme color */
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

#loading-spinner.hidden {
    display: none;
}

#canvas-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transition: visibility 0s linear;
}

#ui-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    pointer-events: none;
}

#approx-height, #approx-total-height, #approx-length, #bottom-flight-length, #top-flight-length {
    color: #555555;
    font-size: 0.85em;
}

#controls, #quote-controls {
    pointer-events: auto;
    background-color: white;
    padding: 30px;
    border-radius: 0px;
    border: 2px solid black;
    margin: 15px;
    z-index: 997;
}

#controls {
    max-width: 350px;
}

#controls .underLine {
    border-bottom: solid 2px #5bb752;
    padding-bottom: 10px;
}

#quote-controls {
    max-width: 350px;
    margin-left: auto;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    right: 0;
}

#price {
    font-size: 1.6rem;
    font-weight: bold;
    color: #5bb752;
    margin-bottom: 1rem;
}

.price-blur {
    filter: blur(5px);
    user-select: none;
    pointer-events: none;
  }
  
  .price-container {
    position: relative;
    margin-bottom: 0;
    width: 100%;
  }
  
  .price-overlay {
    position: relative; /* Change from absolute to relative */
    width: 100%;
    margin-bottom: 10px; /* Add spacing after the price heading */
    background: none; /* Remove background */
    z-index: 1; /* Lower z-index */
  }
  
  #viewPriceBtn {
    border: 2px solid black;
    border-radius: 0;
    background-color: white;
    padding: 8px;
    width: 100%;
    color: #5bb752;
    font-weight: 800;
    font-size: 0.8em;
    text-transform: uppercase;
    cursor: pointer;
    text-align: center;
    display: block;
    margin-bottom: 10px; /* Add spacing between buttons */
  }
  
  #viewPriceBtn:hover {
    background-color: #4a9642;
  }

.radio-inline {
    display: inline-block;
    padding: 0 5px;
}

#controls label {
    font-family: "Nunito Sans", sans-serif;
    font-weight: 600;
    font-size: 1em;
    text-transform: uppercase;
    display: block;
    margin-top: 10px;
}

#controls label.radio-inline {
    display: inline-block;
    text-transform: capitalize;
    font-weight: 400;
    font-size: 0.8em;
}

#controls input[type=number] {
    border: solid 1px rgb(221, 228, 234);
}

#controls input[type=range] {
    background: #5bb752;
}

#bottom-flight-slider-container, #top-flight-slider-container {
    display: none;
}

#menu-toggle {
    display: none;
    align-items: center; /* Vertically center the items */
    gap: 10px; /* Space between hamburger and text */
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 999;
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    pointer-events: auto;
    transition: right 0.3s ease, left 0.3s ease;
}
.hamburger {
    width: 24px;
    height: 20px;
    position: relative;
    flex-shrink: 0; /* Prevent the hamburger from shrinking */
}
.hamburger span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: #5bb752;
    border-radius: 3px;
    transition: .25s ease-in-out;
  }
  
  .hamburger span:nth-child(1) {
    top: 0;
  }
  
  .hamburger span:nth-child(2) {
    top: 8px;
  }
  
  .hamburger span:nth-child(3) {
    top: 16px;
  }
  
  /* X transformation when menu is open */
  #menu-toggle.open .hamburger span:nth-child(1) {
    top: 8px;
    transform: rotate(45deg);
  }
  #menu-toggle.open .hamburger span:nth-child(2) {
    opacity: 0;
  }
  
  #menu-toggle.open .hamburger span:nth-child(3) {
    top: 8px;
    transform: rotate(-45deg);
  }

/* Update Address Section Styles */
#update-address-section, #specsChev {
    border-top: 2px solid #5bb752;
    margin-top: 20px;
    padding-top: 10px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

#update-address-section:not(.hidden), #specsChev:not(.hidden) {
    opacity: 1;
}

#update-address-section h3 {
    color: #5bb752;
    font-size: 1em;
    font-weight: 600;
    text-transform: uppercase;
}

#address-chevron {
    color: #5bb752;
    transition: transform 0.2s ease;
}

#address-chevron.collapsed {
    transform: rotate(180deg);
}

#address-update-form {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

#address-update-form:not(.hidden) {
    max-height: 200px;
}

#new-site-address {
    width: 100%;
    padding: 8px;
    border: 1px solid #5bb752;
    border-radius: 4px;
    color: #000000;
    background-color: #ffffff;
    margin-bottom: 10px;
}

#update-address-btn {
    width: 100%;
    background-color: #5bb752;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

#update-address-btn:hover {
    background-color: #4a9642;
}

#update-address-section .current-address {
    color: #000000;
    margin: 10px 0;
    padding: 8px;
    background-color: #f5f5f5;
    border-radius: 4px;
}

/* Overlay and Form Styles */
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: none;
    display: flex;
    justify-content: center;
    align-items: stretch;
    z-index: 1000;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(5px);
}

.form-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    background: linear-gradient(0deg, rgba(57,77,55,0.85) 0%, rgba(91,183,82,0.9) 60%);
    overflow-y: auto;
}

.hero-section {
    padding: 4rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: center;
    text-align: right;
    width: 50%;
    min-height: min-content;
}

.hero-title {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.title-line {
    display: block;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 900;
    font-style: italic;
    font-size: clamp(1.5rem, 8vw, 4.5rem);
    line-height: 1.1;
    color: white;
    text-transform: uppercase;
    white-space: nowrap;
    width: 100%;
}

.hero-subtitle {
    color: white;
    font-size: 1.25rem;
    line-height: 1.6;
    max-width: 600px;
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    font-weight: bold;
    font-style: italic;
}

.form-section {
    padding: 4rem;
    display: flex;
    align-items: center;
    width: 50%;
    overflow-y: auto;
}

#access-form {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}

.form-field {
    position: relative;
    margin-bottom: 2.5rem;
}

.form-field input {
    width: 100%;
    padding: 0.75rem 0;
    border: none;
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
    background: none;
    font-size: 1rem;
    color: white;
    transition: all 0.2s;
}

.form-field input:focus {
    outline: none;
    border-bottom-color: white;
}

.form-field input::placeholder {
    color: transparent;
}

.form-field label {
    position: absolute;
    left: 0;
    top: 0.75rem;
    font-size: 1rem;
    color: white;
    transition: all 0.2s ease-out;
    pointer-events: none;
}

.form-field input:focus ~ label,
.form-field input:not(:placeholder-shown) ~ label {
    top: -1.25rem;
    font-size: 0.875rem;
    color: white;
}

.submit-btn {
    float: right;
    padding: 1rem;
    background: none;
    color: white;
    border: solid 2px white;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 1.1em;
    letter-spacing: 1px;
    transition: all 0.15s ease;
    text-align: right;
}

.submit-btn span {
    margin-right: 0.5rem;
    transition: all 0.15s ease;
}

.submit-btn svg {
    height: 24px;
    width: 24px;
    transform: translateX(0);
    transition: all 0.2s ease;
}

.submit-btn:hover {
    letter-spacing: 3px;
    border: solid 3px white;
}

.submit-btn:hover span {
    margin-right: .8rem;
}

.submit-btn:hover svg {
    transform: translateX(7px);
}

/* Notification Styles */
.notification-success {
    position: fixed;
    top: 20px;
    right: 20px;
    background-color: #5bb752;
    color: white;
    padding: 1rem;
    border-radius: 4px;
    z-index: 1000;
    animation: slideIn 0.3s ease-out;
}

.notification-error {
    background-color: #dc3545;
    color: white;
    padding: 10px;
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    border-radius: 5px;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Google Places Autocomplete Styles */
.pac-container {
    border-radius: 0;
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    margin-top: 2px;
    background-color: white;
    z-index: 1100 !important;
}

.pac-item {
    padding: 8px;
    font-family: "nunito sans", sans-serif;
    border: none;
    color: black;
}

.pac-item:hover {
    background-color: rgba(91, 183, 82, 0.1);
}

.pac-container::after,
.pac-logo::after {
    display: none !important;
}

/* OTP Styles */
#otp-section {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(57,77,55,0.95) 0%, rgba(91,183,82,0.95) 60%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 1001;
}

#otp-section:not(.hidden) {
    opacity: 1;
    visibility: visible;
}

#otp-section .form-field {
    width: 100%;
    max-width: 300px;
}

#otp-section input {
    text-align: center;
    letter-spacing: 0.5em;
    font-size: 1.5em;
}

#otp-section p {
    color: white;
    text-align: center;
    max-width: 300px;
    margin: 1rem auto;
}

#otp-section button {
    margin-top: 1rem;
}

#resend-otp {
    background: none;
}

/* Tooltip styles */
.tooltip-container {
    position: relative;
    display: inline-block;
}

.question-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background-color: #5bb752;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
}

.tooltip-text {
    visibility: hidden;
    width: 200px;
    background-color: white;
    color: #333;
    text-align: center;
    border-radius: 4px;
    padding: 8px;
    position: absolute;
    z-index: 1000;
    top: 50%;
    right: 30px;
    transform: translateXY(30%, -150%);
    opacity: 0;
    transition: opacity 0.3s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    border: 1px solid #ddd;
    font-size: 12px;
    pointer-events: none;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

/* Add a small triangle at the left of the tooltip */
.tooltip-text::after {
    content: "";
    position: absolute;
    top: 50%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent white transparent transparent;
}

/* Mobile and Tablet Styles */
@media (max-width: 1024px) {
    .form-content {
        flex-direction: column;
        min-height: 100vh;
    }

    .hero-section {
        width: 100%;
        padding: 1.5rem;
        min-height: auto;
        text-align: left;
    }

    .hero-title {
        align-items: flex-start;
    }

    .title-line {
        font-size: clamp(1.5rem, 6vw, 2.5rem);
    }

    .hero-subtitle {
        font-size: 1rem;
        margin: 1rem 0;
        text-align: left;
    }

    .form-section {
        width: 100%;
        padding: 1.5rem;
    }

    #access-form {
        margin-top: 0;
        padding-bottom: 2rem;
    }

    #menu-toggle {
        display: flex;
        position: fixed;
        top: 15px;
        left: 15px;
        z-index: 999;
        background-color: white;
        padding: 10px;
        border-radius: 0px;
        border: solid 2px #000;
        cursor: pointer;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
        pointer-events: auto;
        transition: right 0.3s ease, left 0.3s ease;
        text-transform: uppercase;
        font-size: 0.9em;
        font-weight: bold;
    }
    #menu-toggle {
        display: flex; /* Change from 'block' to 'flex' */
    }

    #controls {
        max-width: none;
        width: 100%;
        margin: 0;
        padding-top: 75px;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
        position: fixed;
        top: 0;
        left: 0;
        height: auto;
        z-index: 998;
        overflow-y: auto;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    }

    #controls.open {
        transform: translateX(0);
    }

    #quote-controls {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        max-width: none;
        max-height: 200px;
        margin: 0;
        padding: 15px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        border-radius: 0;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    #quote-controls .mb-4 {
        flex: 1;
    }

    #quote-controls button {
        flex: 3;
        margin-left: 10px;
    }
    #stair-type-container,
    #stair-specs-container {
        display: none;
    }
    
    #stair-type-container.visible,
    #stair-specs-container.visible {
        display: block;
    }
    #quote-controls {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        max-width: none;
        margin: 0;
        padding: 15px;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        border-radius: 0;
        overflow-y: auto;
        display: flex;
        flex-direction: column; /* Change to column for stacking */
        gap: 10px; /* Add space between stacked elements */
    }

    #quote-controls .mb-4 {
        width: 100%;
        margin-bottom: 0; /* Remove margin since we're using gap */
    }

    #quote-controls button {
        width: 100%;
        margin-left: 0; /* Remove margin since items are stacked */
    }

    #submitQuoteBtn {
        font-size: clamp(0.75rem, 2.5vw, 0.9rem); /* Responsive font size */
        padding: 10px; /* Slightly reduce padding for mobile */
        white-space: nowrap; /* Prevent text wrapping */
        overflow: hidden; /* Prevent overflow */
        text-overflow: ellipsis; /* Add ellipsis if text overflows */
    }
    #viewPriceBtn {
        font-size: clamp(0.75rem, 2.5vw, 0.9rem);
        padding: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    #price, #quote-controls h2 {
        font-size: clamp(1rem, 3vw, 1.2rem); /* Responsive font size for price */
        text-align: center;
    }
    .tooltip-text {
        width: 150px;
    }
}

@media (max-width: 380px) {
    .title-line {
        font-size: clamp(1.2rem, 5vw, 2rem);
    }

    .hero-section {
        padding: 1rem;
    }

    .form-section {
        padding: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,+BAA+B;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B,EAAE,2BAA2B;IAC1D,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;IAC1C,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB,EAAE,qCAAqC;IACzD,WAAW;IACX,mBAAmB,EAAE,wCAAwC;IAC7D,gBAAgB,EAAE,sBAAsB;IACxC,UAAU,EAAE,kBAAkB;EAChC;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,gCAAgC;IACrD,SAAS,EAAE,qCAAqC;IAChD,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,oBAAoB;IACpB,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc,EAAE,yCAAyC;AAC7D;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA,uCAAuC;EACvC;IACE,QAAQ;IACR,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,yBAAyB;EAC3B;;AAEF,kCAAkC;AAClC;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kFAAkF;IAClF,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iDAAiD;IACjD,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,sCAAsC;AACtC;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mFAAmF;IACnF,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,mDAAmD;IACnD,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,WAAW;IACX,kCAAkC;IAClC,UAAU;IACV,wBAAwB;IACxB,qCAAqC;IACrC,sBAAsB;IACtB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,oDAAoD;AACpD;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA,6BAA6B;AAC7B;IACI;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;;IAEA;QACI,aAAa;QACb,eAAe;QACf,SAAS;QACT,UAAU;QACV,YAAY;QACZ,uBAAuB;QACvB,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,0CAA0C;QAC1C,oBAAoB;QACpB,2CAA2C;QAC3C,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,aAAa,EAAE,kCAAkC;IACrD;;IAEA;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,iBAAiB;QACjB,4BAA4B;QAC5B,+BAA+B;QAC/B,eAAe;QACf,MAAM;QACN,OAAO;QACP,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,0CAA0C;QAC1C,wCAAwC;IAC5C;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,SAAS;QACT,aAAa;QACb,0CAA0C;QAC1C,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,OAAO;QACP,iBAAiB;IACrB;IACA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,cAAc;IAClB;IACA;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,eAAe;QACf,SAAS;QACT,aAAa;QACb,0CAA0C;QAC1C,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,sBAAsB,EAAE,kCAAkC;QAC1D,SAAS,EAAE,uCAAuC;IACtD;;IAEA;QACI,WAAW;QACX,gBAAgB,EAAE,wCAAwC;IAC9D;;IAEA;QACI,WAAW;QACX,cAAc,EAAE,0CAA0C;IAC9D;;IAEA;QACI,wCAAwC,EAAE,yBAAyB;QACnE,aAAa,EAAE,uCAAuC;QACtD,mBAAmB,EAAE,0BAA0B;QAC/C,gBAAgB,EAAE,qBAAqB;QACvC,uBAAuB,EAAE,mCAAmC;IAChE;IACA;QACI,wCAAwC;QACxC,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,mCAAmC,EAAE,mCAAmC;QACxE,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["body, html {\n    margin: 0;\n    height: 100%;\n    overflow: hidden;\n    font-family: \"nunito sans\", sans-serif;\n    font-size: 16px;\n}\n\nh1 {\n    font-size: 2em;\n    font-weight: 800;\n    color: #5bb752;\n}\n\nh2 {\n    font-size: 1.5em;\n    font-weight: 800;\n    color: #5bb752;\n}\n\nh3 {\n    font-size: 1.1em;\n    font-weight: 600;\n    color: #5bb752;\n}\n\nh4 {\n    font-size: 1em;\n    font-weight: 600;\n    color: #5bb752;\n}\n\np {\n    font-size: 1em;\n    font-weight: 400;\n    color: #000;\n}\n\n.hidden {\n    display: none!important;\n}\n\n#loading-spinner {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000; /* Higher than other elements */\n}\n\n.spinner {\n    width: 50px;\n    height: 50px;\n    border: 5px solid #f3f3f3;\n    border-top: 5px solid #5bb752; /* Match your theme color */\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n#loading-spinner.hidden {\n    display: none;\n}\n\n#canvas-container {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    transition: visibility 0s linear;\n}\n\n#ui-container {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    pointer-events: none;\n}\n\n#approx-height, #approx-total-height, #approx-length, #bottom-flight-length, #top-flight-length {\n    color: #555555;\n    font-size: 0.85em;\n}\n\n#controls, #quote-controls {\n    pointer-events: auto;\n    background-color: white;\n    padding: 30px;\n    border-radius: 0px;\n    border: 2px solid black;\n    margin: 15px;\n    z-index: 997;\n}\n\n#controls {\n    max-width: 350px;\n}\n\n#controls .underLine {\n    border-bottom: solid 2px #5bb752;\n    padding-bottom: 10px;\n}\n\n#quote-controls {\n    max-width: 350px;\n    margin-left: auto;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n    position: fixed;\n    bottom: 0;\n    right: 0;\n}\n\n#price {\n    font-size: 1.6rem;\n    font-weight: bold;\n    color: #5bb752;\n    margin-bottom: 1rem;\n}\n\n.price-blur {\n    filter: blur(5px);\n    user-select: none;\n    pointer-events: none;\n  }\n  \n  .price-container {\n    position: relative;\n    margin-bottom: 0;\n    width: 100%;\n  }\n  \n  .price-overlay {\n    position: relative; /* Change from absolute to relative */\n    width: 100%;\n    margin-bottom: 10px; /* Add spacing after the price heading */\n    background: none; /* Remove background */\n    z-index: 1; /* Lower z-index */\n  }\n  \n  #viewPriceBtn {\n    border: 2px solid black;\n    border-radius: 0;\n    background-color: white;\n    padding: 8px;\n    width: 100%;\n    color: #5bb752;\n    font-weight: 800;\n    font-size: 0.8em;\n    text-transform: uppercase;\n    cursor: pointer;\n    text-align: center;\n    display: block;\n    margin-bottom: 10px; /* Add spacing between buttons */\n  }\n  \n  #viewPriceBtn:hover {\n    background-color: #4a9642;\n  }\n\n.radio-inline {\n    display: inline-block;\n    padding: 0 5px;\n}\n\n#controls label {\n    font-family: \"Nunito Sans\", sans-serif;\n    font-weight: 600;\n    font-size: 1em;\n    text-transform: uppercase;\n    display: block;\n    margin-top: 10px;\n}\n\n#controls label.radio-inline {\n    display: inline-block;\n    text-transform: capitalize;\n    font-weight: 400;\n    font-size: 0.8em;\n}\n\n#controls input[type=number] {\n    border: solid 1px rgb(221, 228, 234);\n}\n\n#controls input[type=range] {\n    background: #5bb752;\n}\n\n#bottom-flight-slider-container, #top-flight-slider-container {\n    display: none;\n}\n\n#menu-toggle {\n    display: none;\n    align-items: center; /* Vertically center the items */\n    gap: 10px; /* Space between hamburger and text */\n    position: fixed;\n    top: 15px;\n    left: 15px;\n    z-index: 999;\n    background-color: white;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\n    pointer-events: auto;\n    transition: right 0.3s ease, left 0.3s ease;\n}\n.hamburger {\n    width: 24px;\n    height: 20px;\n    position: relative;\n    flex-shrink: 0; /* Prevent the hamburger from shrinking */\n}\n.hamburger span {\n    display: block;\n    position: absolute;\n    height: 3px;\n    width: 100%;\n    background: #5bb752;\n    border-radius: 3px;\n    transition: .25s ease-in-out;\n  }\n  \n  .hamburger span:nth-child(1) {\n    top: 0;\n  }\n  \n  .hamburger span:nth-child(2) {\n    top: 8px;\n  }\n  \n  .hamburger span:nth-child(3) {\n    top: 16px;\n  }\n  \n  /* X transformation when menu is open */\n  #menu-toggle.open .hamburger span:nth-child(1) {\n    top: 8px;\n    transform: rotate(45deg);\n  }\n  #menu-toggle.open .hamburger span:nth-child(2) {\n    opacity: 0;\n  }\n  \n  #menu-toggle.open .hamburger span:nth-child(3) {\n    top: 8px;\n    transform: rotate(-45deg);\n  }\n\n/* Update Address Section Styles */\n#update-address-section, #specsChev {\n    border-top: 2px solid #5bb752;\n    margin-top: 20px;\n    padding-top: 10px;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n#update-address-section:not(.hidden), #specsChev:not(.hidden) {\n    opacity: 1;\n}\n\n#update-address-section h3 {\n    color: #5bb752;\n    font-size: 1em;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n#address-chevron {\n    color: #5bb752;\n    transition: transform 0.2s ease;\n}\n\n#address-chevron.collapsed {\n    transform: rotate(180deg);\n}\n\n#address-update-form {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n}\n\n#address-update-form:not(.hidden) {\n    max-height: 200px;\n}\n\n#new-site-address {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #5bb752;\n    border-radius: 4px;\n    color: #000000;\n    background-color: #ffffff;\n    margin-bottom: 10px;\n}\n\n#update-address-btn {\n    width: 100%;\n    background-color: #5bb752;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n#update-address-btn:hover {\n    background-color: #4a9642;\n}\n\n#update-address-section .current-address {\n    color: #000000;\n    margin: 10px 0;\n    padding: 8px;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n}\n\n/* Overlay and Form Styles */\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: none;\n    display: flex;\n    justify-content: center;\n    align-items: stretch;\n    z-index: 1000;\n    -webkit-backdrop-filter: blur(3px);\n    backdrop-filter: blur(5px);\n}\n\n.form-content {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    background: linear-gradient(0deg, rgba(57,77,55,0.85) 0%, rgba(91,183,82,0.9) 60%);\n    overflow-y: auto;\n}\n\n.hero-section {\n    padding: 4rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-self: center;\n    text-align: right;\n    width: 50%;\n    min-height: min-content;\n}\n\n.hero-title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.title-line {\n    display: block;\n    font-family: 'Nunito Sans', sans-serif;\n    font-weight: 900;\n    font-style: italic;\n    font-size: clamp(1.5rem, 8vw, 4.5rem);\n    line-height: 1.1;\n    color: white;\n    text-transform: uppercase;\n    white-space: nowrap;\n    width: 100%;\n}\n\n.hero-subtitle {\n    color: white;\n    font-size: 1.25rem;\n    line-height: 1.6;\n    max-width: 600px;\n    margin-top: 1.5rem;\n    margin-bottom: 2rem;\n    font-weight: bold;\n    font-style: italic;\n}\n\n.form-section {\n    padding: 4rem;\n    display: flex;\n    align-items: center;\n    width: 50%;\n    overflow-y: auto;\n}\n\n#access-form {\n    width: 100%;\n    max-width: 500px;\n    margin: 0 auto;\n}\n\n.form-field {\n    position: relative;\n    margin-bottom: 2.5rem;\n}\n\n.form-field input {\n    width: 100%;\n    padding: 0.75rem 0;\n    border: none;\n    border-bottom: 2px solid rgba(255, 255, 255, 0.3);\n    background: none;\n    font-size: 1rem;\n    color: white;\n    transition: all 0.2s;\n}\n\n.form-field input:focus {\n    outline: none;\n    border-bottom-color: white;\n}\n\n.form-field input::placeholder {\n    color: transparent;\n}\n\n.form-field label {\n    position: absolute;\n    left: 0;\n    top: 0.75rem;\n    font-size: 1rem;\n    color: white;\n    transition: all 0.2s ease-out;\n    pointer-events: none;\n}\n\n.form-field input:focus ~ label,\n.form-field input:not(:placeholder-shown) ~ label {\n    top: -1.25rem;\n    font-size: 0.875rem;\n    color: white;\n}\n\n.submit-btn {\n    float: right;\n    padding: 1rem;\n    background: none;\n    color: white;\n    border: solid 2px white;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    font-size: 1.1em;\n    letter-spacing: 1px;\n    transition: all 0.15s ease;\n    text-align: right;\n}\n\n.submit-btn span {\n    margin-right: 0.5rem;\n    transition: all 0.15s ease;\n}\n\n.submit-btn svg {\n    height: 24px;\n    width: 24px;\n    transform: translateX(0);\n    transition: all 0.2s ease;\n}\n\n.submit-btn:hover {\n    letter-spacing: 3px;\n    border: solid 3px white;\n}\n\n.submit-btn:hover span {\n    margin-right: .8rem;\n}\n\n.submit-btn:hover svg {\n    transform: translateX(7px);\n}\n\n/* Notification Styles */\n.notification-success {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    background-color: #5bb752;\n    color: white;\n    padding: 1rem;\n    border-radius: 4px;\n    z-index: 1000;\n    animation: slideIn 0.3s ease-out;\n}\n\n.notification-error {\n    background-color: #dc3545;\n    color: white;\n    padding: 10px;\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 1000;\n    border-radius: 5px;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* Google Places Autocomplete Styles */\n.pac-container {\n    border-radius: 0;\n    border: none;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n    margin-top: 2px;\n    background-color: white;\n    z-index: 1100 !important;\n}\n\n.pac-item {\n    padding: 8px;\n    font-family: \"nunito sans\", sans-serif;\n    border: none;\n    color: black;\n}\n\n.pac-item:hover {\n    background-color: rgba(91, 183, 82, 0.1);\n}\n\n.pac-container::after,\n.pac-logo::after {\n    display: none !important;\n}\n\n/* OTP Styles */\n#otp-section {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(0deg, rgba(57,77,55,0.95) 0%, rgba(91,183,82,0.95) 60%);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease, visibility 0.3s ease;\n    z-index: 1001;\n}\n\n#otp-section:not(.hidden) {\n    opacity: 1;\n    visibility: visible;\n}\n\n#otp-section .form-field {\n    width: 100%;\n    max-width: 300px;\n}\n\n#otp-section input {\n    text-align: center;\n    letter-spacing: 0.5em;\n    font-size: 1.5em;\n}\n\n#otp-section p {\n    color: white;\n    text-align: center;\n    max-width: 300px;\n    margin: 1rem auto;\n}\n\n#otp-section button {\n    margin-top: 1rem;\n}\n\n#resend-otp {\n    background: none;\n}\n\n/* Tooltip styles */\n.tooltip-container {\n    position: relative;\n    display: inline-block;\n}\n\n.question-mark {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    background-color: #5bb752;\n    color: white;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.tooltip-text {\n    visibility: hidden;\n    width: 200px;\n    background-color: white;\n    color: #333;\n    text-align: center;\n    border-radius: 4px;\n    padding: 8px;\n    position: absolute;\n    z-index: 1000;\n    top: 50%;\n    right: 30px;\n    transform: translateXY(30%, -150%);\n    opacity: 0;\n    transition: opacity 0.3s;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n    border: 1px solid #ddd;\n    font-size: 12px;\n    pointer-events: none;\n}\n\n.tooltip-container:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Add a small triangle at the left of the tooltip */\n.tooltip-text::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    right: 100%;\n    margin-top: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent white transparent transparent;\n}\n\n/* Mobile and Tablet Styles */\n@media (max-width: 1024px) {\n    .form-content {\n        flex-direction: column;\n        min-height: 100vh;\n    }\n\n    .hero-section {\n        width: 100%;\n        padding: 1.5rem;\n        min-height: auto;\n        text-align: left;\n    }\n\n    .hero-title {\n        align-items: flex-start;\n    }\n\n    .title-line {\n        font-size: clamp(1.5rem, 6vw, 2.5rem);\n    }\n\n    .hero-subtitle {\n        font-size: 1rem;\n        margin: 1rem 0;\n        text-align: left;\n    }\n\n    .form-section {\n        width: 100%;\n        padding: 1.5rem;\n    }\n\n    #access-form {\n        margin-top: 0;\n        padding-bottom: 2rem;\n    }\n\n    #menu-toggle {\n        display: flex;\n        position: fixed;\n        top: 15px;\n        left: 15px;\n        z-index: 999;\n        background-color: white;\n        padding: 10px;\n        border-radius: 0px;\n        border: solid 2px #000;\n        cursor: pointer;\n        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\n        pointer-events: auto;\n        transition: right 0.3s ease, left 0.3s ease;\n        text-transform: uppercase;\n        font-size: 0.9em;\n        font-weight: bold;\n    }\n    #menu-toggle {\n        display: flex; /* Change from 'block' to 'flex' */\n    }\n\n    #controls {\n        max-width: none;\n        width: 100%;\n        margin: 0;\n        padding-top: 75px;\n        transform: translateX(-100%);\n        transition: transform 0.3s ease;\n        position: fixed;\n        top: 0;\n        left: 0;\n        height: auto;\n        z-index: 998;\n        overflow-y: auto;\n        background-color: rgba(255, 255, 255, 0.8);\n        box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n    }\n\n    #controls.open {\n        transform: translateX(0);\n    }\n\n    #quote-controls {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        max-width: none;\n        max-height: 200px;\n        margin: 0;\n        padding: 15px;\n        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n        border-radius: 0;\n        overflow-y: auto;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    #quote-controls .mb-4 {\n        flex: 1;\n    }\n\n    #quote-controls button {\n        flex: 3;\n        margin-left: 10px;\n    }\n    #stair-type-container,\n    #stair-specs-container {\n        display: none;\n    }\n    \n    #stair-type-container.visible,\n    #stair-specs-container.visible {\n        display: block;\n    }\n    #quote-controls {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        max-width: none;\n        margin: 0;\n        padding: 15px;\n        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n        border-radius: 0;\n        overflow-y: auto;\n        display: flex;\n        flex-direction: column; /* Change to column for stacking */\n        gap: 10px; /* Add space between stacked elements */\n    }\n\n    #quote-controls .mb-4 {\n        width: 100%;\n        margin-bottom: 0; /* Remove margin since we're using gap */\n    }\n\n    #quote-controls button {\n        width: 100%;\n        margin-left: 0; /* Remove margin since items are stacked */\n    }\n\n    #submitQuoteBtn {\n        font-size: clamp(0.75rem, 2.5vw, 0.9rem); /* Responsive font size */\n        padding: 10px; /* Slightly reduce padding for mobile */\n        white-space: nowrap; /* Prevent text wrapping */\n        overflow: hidden; /* Prevent overflow */\n        text-overflow: ellipsis; /* Add ellipsis if text overflows */\n    }\n    #viewPriceBtn {\n        font-size: clamp(0.75rem, 2.5vw, 0.9rem);\n        padding: 10px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    #price, #quote-controls h2 {\n        font-size: clamp(1rem, 3vw, 1.2rem); /* Responsive font size for price */\n        text-align: center;\n    }\n    .tooltip-text {\n        width: 150px;\n    }\n}\n\n@media (max-width: 380px) {\n    .title-line {\n        font-size: clamp(1.2rem, 5vw, 2rem);\n    }\n\n    .hero-section {\n        padding: 1rem;\n    }\n\n    .form-section {\n        padding: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
